import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { newcreateEvent } from "../../../controller/c_events.js";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const INITIAL_FORM = {
  etitle: "",
  isfree: 1,
  location: "",
  details: [{ heading: "", content: "" }],
  schedules: [
    { startdate: "", enddate: "", timeduration: "", deliverymode: "" },
  ],
  payments: [{ country: "", amount: "" }],
  image: null,
};

export default function AddNewEvent() {
    const userid= useSelector((state)=>state.auth.login.userid);
  const [form, setForm] = useState(INITIAL_FORM);
  const [errors, setErrors] = useState({});
  const [imagePreview, setImagePreview] = useState(null);
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  // -----------------------------
  // Basic Input
  // -----------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // -----------------------------
  // Image Upload
  // -----------------------------
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setForm((prev) => ({ ...prev, image: file }));
      setImagePreview(URL.createObjectURL(file));
    }
  };

  // -----------------------------
  // DETAILS (Dynamic)
  // -----------------------------
  const handleDetailChange = (index, field, value) => {
    setForm((prev) => ({
      ...prev,
      details: prev.details.map((d, i) =>
        i === index ? { ...d, [field]: value } : d
      ),
    }));
  };
  const addDetail = () =>
    setForm((prev) => ({
      ...prev,
      details: [...prev.details, { heading: "", content: "" }],
    }));
  const removeDetail = (index) => {
    if (form.details.length === 1) return;
    setForm((prev) => ({
      ...prev,
      details: prev.details.filter((_, i) => i !== index),
    }));
  };

  // -----------------------------
  // SCHEDULES (Dynamic)
  // -----------------------------
  const handleScheduleChange = (index, field, value) => {
    setForm((prev) => ({
      ...prev,
      schedules: prev.schedules.map((s, i) =>
        i === index ? { ...s, [field]: value } : s
      ),
    }));
  };
  const addSchedule = () =>
    setForm((prev) => ({
      ...prev,
      schedules: [
        ...prev.schedules,
        { startdate: "", enddate: "", timeduration: "", deliverymode: "" },
      ],
    }));
  const removeSchedule = (index) => {
    if (form.schedules.length === 1) return;
    setForm((prev) => ({
      ...prev,
      schedules: prev.schedules.filter((_, i) => i !== index),
    }));
  };

  // -----------------------------
  // PAYMENTS (Dynamic)
  // -----------------------------
  const handlePaymentChange = (index, field, value) => {
    setForm((prev) => ({
      ...prev,
      payments: prev.payments.map((p, i) =>
        i === index ? { ...p, [field]: value } : p
      ),
    }));
  };
  const addPayment = () =>
    setForm((prev) => ({
      ...prev,
      payments: [...prev.payments, { country: "", amount: "" }],
    }));
  const removePayment = (index) => {
    if (form.payments.length === 1) return;
    setForm((prev) => ({
      ...prev,
      payments: prev.payments.filter((_, i) => i !== index),
    }));
  };

  // -----------------------------
  // Validation
  // -----------------------------
  const validate = () => {
    let err = {};

    if (!form.etitle.trim()) err.etitle = "Title is required";

    form.schedules.forEach((s, i) => {
      if (!s.startdate) err[`startdate_${i}`] = "Start date required";
      if (!s.deliverymode) err[`mode_${i}`] = "Mode required";
    });

    form.details.forEach((d, i) => {
      if (!d.heading) err[`heading_${i}`] = "Heading required";
    });

    form.payments.forEach((p, i) => {
      if (!p.country) err[`country_${i}`] = "Country required";
      if (!p.amount || isNaN(p.amount) || Number(p.amount) <= 0)
        err[`amount_${i}`] = "Valid amount required";
    });

    if (!form.image) err.image = "Event image required";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  // -----------------------------
  // Submit
  // -----------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;
    setSubmitting(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([key, value]) => {
        if (key === "details" || key === "schedules" || key === "payments") {
          fd.append(key, JSON.stringify(value));
        } else {
          fd.append(key, value);
        }
      });

      const response = await newcreateEvent(fd,userid);

      if (response?.state) {
        toast.success("Event created successfully");
        setSubmitting(false);
        navigate("/admin/events");
        
      } else {
        setSubmitting(false);
        toast.error(response?.message || "Failed to create event");
      }
    } catch (err) {
     setSubmitting(false);
      toast.error("Something went wrong");
    }
  };

  return (
    <div className=" mt-2">
      <div className="card bg-dark text-white">
        <div className="card-body">
          <h3 className="mb-4">Create New Event</h3>
          <form onSubmit={handleSubmit}>
            {/* Title */}
            <div className="mb-3">
              <label>Event Title</label>
              <input
                type="text"
                name="etitle"
                className="form-control form-control-dark"
                value={form.etitle}
                onChange={handleChange}
              />
              {errors.etitle && <small className="text-danger">{errors.etitle}</small>}
            </div>

            {/* Free / Paid */}
            <div className="mb-3">
              <label>Is Free?</label>
              <select
                name="isfree"
                className="form-control form-control-dark"
                value={form.isfree}
                onChange={handleChange}
              >
                <option value={1}>Free</option>
                <option value={0}>Paid</option>
              </select>
            </div>

            {/* Location */}
            <div className="mb-3">
              <label>Location</label>
              <input
                type="text"
                name="location"
                className="form-control form-control-dark"
                value={form.location}
                onChange={handleChange}
              />
            </div>

            {/* IMAGE */}
            <div className="mb-3">
              <label>Event Image</label>
              <input
                type="file"
                className="form-control form-control-dark"
                accept="image/*"
                onChange={handleImageChange}
              />
              {errors.image && <small className="text-danger">{errors.image}</small>}
              {imagePreview && (
                <img src={imagePreview} alt="Preview" className="mt-2" style={{ maxHeight: "200px" }} />
              )}
            </div>

            {/* ---------------- SCHEDULES ---------------- */}
            <h5>Event Schedules</h5>
            {form.schedules.map((sch, i) => (
              <div key={i} className="border p-3 mb-3 rounded">
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <input
                      type="date"
                      className="form-control form-control-dark"
                      value={sch.startdate}
                      onChange={(e) => handleScheduleChange(i, "startdate", e.target.value)}
                    />
                    {errors[`startdate_${i}`] && (
                      <small className="text-danger">{errors[`startdate_${i}`]}</small>
                    )}
                  </div>
                  <div className="col-md-6 mb-2">
                    <input
                      type="date"
                      className="form-control form-control-dark"
                      value={sch.enddate}
                      onChange={(e) => handleScheduleChange(i, "enddate", e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <input
                      type="text"
                      placeholder="Time"
                      className="form-control form-control-dark"
                      value={sch.timeduration}
                      onChange={(e) => handleScheduleChange(i, "timeduration", e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <select
                      className="form-control form-control-dark"
                      value={sch.deliverymode}
                      onChange={(e) => handleScheduleChange(i, "deliverymode", e.target.value)}
                    >
                      <option value="">Mode</option>
                      <option value="Online">Online</option>
                      <option value="Physical">Physical</option>
                    </select>
                    {errors[`mode_${i}`] && (
                      <small className="text-danger">{errors[`mode_${i}`]}</small>
                    )}
                  </div>
                </div>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => removeSchedule(i)}
                  disabled={form.schedules.length === 1}
                >
                  Remove
                </button>
              </div>
            ))}
            <button type="button" className="btn btn-outline-light mb-4" onClick={addSchedule}>
              + Add Schedule
            </button>

            {/* ---------------- DETAILS ---------------- */}
            <h5>Event Details Sections</h5>
            {form.details.map((d, i) => (
              <div key={i} className="border p-3 mb-3 rounded">
                <input
                  type="text"
                  placeholder="Heading"
                  className="form-control form-control-dark mb-2"
                  value={d.heading}
                  onChange={(e) => handleDetailChange(i, "heading", e.target.value)}
                />
                {errors[`heading_${i}`] && (
                  <small className="text-danger">{errors[`heading_${i}`]}</small>
                )}
                <textarea
                  placeholder="Content"
                  className="form-control form-control-dark mb-2"
                  value={d.content}
                  onChange={(e) => handleDetailChange(i, "content", e.target.value)}
                />
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => removeDetail(i)}
                  disabled={form.details.length === 1}
                >
                  Remove
                </button>
              </div>
            ))}
            <button type="button" className="btn btn-outline-light mb-4" onClick={addDetail}>
              + Add Section
            </button>

            {/* ---------------- PAYMENTS ---------------- */}
            <h5>Event Payments by Country</h5>
            {form.payments.map((p, i) => (
              <div key={i} className="border p-3 mb-3 rounded">
                <select
                  className="form-control form-control-dark mb-2"
                  value={p.country}
                  onChange={(e) => handlePaymentChange(i, "country", e.target.value)}
                >
                  <option value="">Select Country</option>
                  <option value="USA">USA</option>
                  <option value="United Kingdom">United Kingdom</option>
                  <option value="Ghana">Ghana</option>
                  <option value="Nigeria">Nigeria</option>
                  {/* Add more countries dynamically if needed */}
                </select>
                {errors[`country_${i}`] && (
                  <small className="text-danger">{errors[`country_${i}`]}</small>
                )}

                <input
                  type="number"
                  placeholder="Amount"
                  className="form-control form-control-dark mb-2"
                  value={p.amount}
                  onChange={(e) => handlePaymentChange(i, "amount", e.target.value)}
                />
                {errors[`amount_${i}`] && (
                  <small className="text-danger">{errors[`amount_${i}`]}</small>
                )}

                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => removePayment(i)}
                  disabled={form.payments.length === 1}
                >
                  Remove
                </button>
              </div>
            ))}
            <button type="button" className="btn btn-outline-light mb-4" onClick={addPayment}>
              + Add Payment
            </button>

            {/* Submit */}
            <div className="d-flex justify-content-between">
              <button type="button" className="btn btn-secondary" onClick={() => navigate("/events")}>
                Cancel
              </button>
              <button  type="submit" className="btn btn-primary" disabled={submitting}>
                {submitting ? "Saving..." : "Save Event"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}